<div class="border rounded-2xl shadow p-1 flex flex-col bg-white w-full">
  <div class="flex justify-between items-center">
    <img
      src="assets/icons/delete.png"
      class="cursor-pointer ml-1 self-start"
      width="18"
      (click)="clearCanvas()"
    >
    <div class="text-sm text-center">{{ city }}, {{ today | date:'dd.MM.yyyy' }}</div>
    <div></div>
  </div>

  <canvas
    #signatureCanvas
    class="bg-gray-50 wrounded-md border w-full h-[95px] portrait:h-[110px] cursor-crosshair"
    [ngClass]="customClass"
  ></canvas>
</div>
